import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isDefaultAppHostname } from '../utils/finder-hostname';

/** Allows PublicFinderComponent on verified custom domains; default app host goes to login. */
export const customDomainEntryGuard: CanActivateFn = () => {
  const router = inject(Router);
  const hostname = window.location.hostname;

  if (isDefaultAppHostname(hostname)) {
    return router.createUrlTree(['/login']);
  }

  return true;
};

/** Prevents wildcard redirect to login on custom domains (still serves public finder SPA). */
export const customDomainWildcardGuard: CanActivateFn = () => {
  const router = inject(Router);
  const hostname = window.location.hostname;

  if (isDefaultAppHostname(hostname)) {
    return router.createUrlTree(['/login']);
  }

  return true;
};
